import { OrderStatus } from '@/coreDomainsModule/entities/arrival';

/**
 * 発注ステータス
 */
export interface OrderStatusDescription {
  status: OrderStatus;
  description: string;
}

export const orderStatusDescriptions: OrderStatusDescription[] = [
  { status: OrderStatus.Recommended, description: 'RecommendedDescription' },
  { status: OrderStatus.ApprovalRequested, description: 'ApprovalRequestedDescription' },
  { status: OrderStatus.ApprovedAwaitingDeliveryDate, description: 'ApprovedAwaitingDeliveryDateDescription' },
  { status: OrderStatus.DeliveryDateConfirmed, description: 'DeliveryDateConfirmedDescription' },
  { status: OrderStatus.QuantityConfirmed, description: 'QuantityConfirmedDescription' },
  { status: OrderStatus.PartialDelivery, description: 'PartialDeliveryDescription' },
  { status: OrderStatus.Confirmed, description: 'ConfirmedDescription' },
  { status: OrderStatus.Delivered, description: 'DeliveredDescription' },
  { status: OrderStatus.DeliveryDelayed, description: 'DeliveryDelayedDescription' },
  { status: OrderStatus.DisplayEnded, description: 'DisplayEndedDescription' },
];

export const filterableOrderStatus: OrderStatus[] = [
  OrderStatus.ApprovedAwaitingDeliveryDate,
  OrderStatus.QuantityConfirmed,
  OrderStatus.DeliveryDateConfirmed,
  OrderStatus.PartialDelivery,
  OrderStatus.Confirmed,
  OrderStatus.Delivered,
  OrderStatus.DeliveryDelayed,
];
